import type { ReactElement, ReactNode } from 'react';

export type FormattedMessage = string | ReactNode[];

export type MessageNode = FormattedMessage | ReactElement;

export default function isFormattedMessage(messageNode: MessageNode): messageNode is FormattedMessage {
	return typeof messageNode === 'string' || Array.isArray(messageNode);
}
